// extracted by mini-css-extract-plugin
export default {"error":"error_error__IYuDK","error_title":"error_error_title__8g4pQ","Shimiring":"error_Shimiring__UaQRW"};